module.exports = __webpack_public_path__ + "static/media/opensans-extrabolditalic-webfont.96797caf.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-extrabolditalic-webfont.woff
// module id = 1022
// module chunks = 0